import React from 'react';
import AccountPage from '../components/AccountPage';
import NewsFeed from '../components/NewsFeed';

const NewsPage = () => {
  return (
    <AccountPage>
      <NewsFeed />
    </AccountPage>
  );
};

export default NewsPage;
